import { render, staticRenderFns } from "./Dayu.vue?vue&type=template&id=8480665c&scoped=true"
import script from "./Dayu.vue?vue&type=script&lang=js"
export * from "./Dayu.vue?vue&type=script&lang=js"
import style0 from "./Dayu.vue?vue&type=style&index=0&id=8480665c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8480665c",
  null
  
)

export default component.exports